import {Stack, Typography, styled} from '@mui/material';

const StyledContent = styled(Stack)`
	padding: 24px 36px 32px;
`;

const StyledDescription = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 28px;
	margin-bottom: 16px;
`;

export {StyledContent, StyledDescription};
